// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import NotificationConstants from 'constants/NotificationConstants'

const NotificationStore = Marty.createStore({
  id: 'NotificationStore',

  getInitialState() {
    return {
      currentNotifications: []
    }
  },

  handlers: {
    notificationDisplayed: NotificationConstants.NOTIFICATION_DISPLAY_DONE,
    pushNotification: NotificationConstants.NOTIFICATION_PUSH,
    clearNotifications: NotificationConstants.CLEAR_NOTIFICATIONS
  },

  pushNotification(notification) {
    const currentNotifications = _.cloneDeep(this.state.currentNotifications)
    currentNotifications.push(notification)
    return this.setState({ currentNotifications })
  },

  getNotifications() {
    return this.state.currentNotifications
  },

  notificationDisplayed() {
    const currentNotifications = _.cloneDeep(this.state.currentNotifications)
    currentNotifications.shift()
    return this.setState({ currentNotifications })
  },

  clearNotifications() {
    return this.setState({ currentNotifications: []})
  }

})

export default NotificationStore



// WEBPACK FOOTER //
// ./src/scripts/stores/NotificationStore.js